module.exports = {
	max_levels: 3,
	level_max: {
		0: 8,
		1: 2,
		2: 2,
	},
	locales: [
		{
			key: 'default',
			value: 'Default',
		},
		{
			key: 'en_US',
			value: 'English',
		},
	],
	persistent_menus: [
		{
			locale: 'default',
			composer_input_disabled: false,
			call_to_actions: [],
		},
	],
	types: [
		{
			key: 'nested',
			value: 'Nested',
		},
		{
			key: 'postback',
			value: 'Post Back',
		},
		{
			key: 'web_url',
			value: 'Web Url',
		},
	],
}
